import Vue from 'vue'
import App from './App.vue'
// import axios from 'axios'
import Vuelidate from 'vuelidate'

import router from './router'
import store from './store'
import VueGoodWizard from 'vue-good-wizard';
import { BootstrapVue, BIcon, BIconPencil, BIconFileRichtext } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue);
Vue.use(VueGoodWizard);
Vue.use(Vuelidate)
Vue.component('BIcon', BIcon)
Vue.component('BIconPencil', BIconPencil)
Vue.component('BIconFileRichtext', BIconFileRichtext)

// axios.defaults.baseURL = 'https://legiox-dc932.firebaseio.com'
// // axios.defaults.headers.common['Authorization'] = 'fasfdsa'
// axios.defaults.headers.get['Accepts'] = 'application/json'

// const reqInterceptor = axios.interceptors.request.use(config => {
//   console.log('Request Interceptor', config)
//   return config
// })
// const resInterceptor = axios.interceptors.response.use(res => {
//   console.log('Response Interceptor', res)
//   return res
// })

// axios.interceptors.request.eject(reqInterceptor)
// axios.interceptors.response.eject(resInterceptor)

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js